<template>
  <div>
    <div style="margin-bottom: 10px">
      <a-button type="primary" @click="refreshClick"
        >刷新列表
        <a-icon type="retweet" />
      </a-button>
      <a-button type="primary" @click="outputNetExcel"
        >导出 7 天内设备网络情况
        <!--<a-icon type="retweet"/>-->
      </a-button>
    </div>
    <div>
      <div style="margin-bottom: 10px">
        <label title="稳定版本号" class="info">稳定版本号</label>
        <a-input
          style="max-width: 100px; margin-right: 20px"
          placeholder="微信插件"
          v-model="min_wechat_ver"
        />
        <a-input
          style="max-width: 100px; margin-right: 20px"
          placeholder="大黄脸"
          v-model="min_manager_ver"
        />
        <a-button type="primary" @click="setMinVersion">保存并检查</a-button>
      </div>
      <div>
        <a-button v-if="!new_device" type="primary" @click="addDevice"
          >点击新增设备ID</a-button
        >
        <a-button v-if="new_device" type="primary" @click="hideDevice"
          >隐藏新增</a-button
        >
        <div v-if="new_device" style="display: inline-block">
          <label title="唯一ID" class="info">唯一ID</label>
          <a-input
            style="max-width: 100px; margin-right: 20px"
            placeholder="唯一ID"
            v-model="new_unique_id"
          />
          <a-button type="primary" @click="newDevice">新增</a-button>
        </div>
      </div>
      <div style="margin-top: 10px">
        搜索设备
        <a-input
          style="max-width: 100px; margin-right: 20px"
          v-model="search_device_id"
          @keydown.enter="searchDevice"
          placeholder="唯一ID"
        />
        <a-input
          style="max-width: 100px; margin-right: 20px"
          v-model="search_bot_username"
          @keydown.enter="searchDevice"
          placeholder="机器人ID"
        />
        <a-button type="primary" @click="searchDevice">搜索</a-button>
        <a-button type="primary" @click="cancelSearchDevice">清空</a-button>
      </div>

      <!--<span v-if="username"> <label title="默认密码" class="info">默认密码</label> {{ password }} </span>-->
    </div>
    <!--<div>-->
    <!--<a-popconfirm placement="top" okText="确认" cancelText="不不不" @confirm="broadcastClick('update_core')">-->
    <!--<template slot="title">-->
    <!--<p>确认要更新所有设备的内核版本吗，慎重！</p>-->
    <!--</template>-->
    <!--<a-button type="primary">更新全部内核程序 <a-icon type="exclamation-circle-o" /></a-button>-->
    <!--</a-popconfirm>-->

    <!--<a-popconfirm placement="top" okText="确认" cancelText="不不不" @confirm="broadcastClick('update_manager')">-->
    <!--<template slot="title">-->
    <!--<p>确认要更新所有设备的管理程序吗，慎重！</p>-->
    <!--</template>-->
    <!--<a-button type="primary">更新全部管理程序 <a-icon type="exclamation-circle-o" /></a-button>-->
    <!--</a-popconfirm>-->

    <!--<a-popconfirm placement="top" okText="确认" cancelText="不不不" @confirm="broadcastClick('clear_log')">-->
    <!--<template slot="title">-->
    <!--<p>确认要清理全部日志文件吗，慎重！</p>-->
    <!--</template>-->
    <!--<a-button type="primary">清理全部日志文件 <a-icon type="exclamation-circle-o" /></a-button>-->
    <!--</a-popconfirm>-->

    <!--<a-popconfirm placement="top" okText="确认" cancelText="不不不" @confirm="broadcastClick('query_balance')">-->
    <!--<template slot="title">-->
    <!--<p>确认要查询所有设备余额吗，慎重！</p>-->
    <!--</template>-->
    <!--<a-button type="primary">查询所有余额 <a-icon type="exclamation-circle-o" /></a-button>-->
    <!--</a-popconfirm>-->

    <!--<a-button type="primary" @click="visible_clear_certain_wifi_all=true">清除wifi<a-icon type="retweet" /></a-button>-->

    <!--<a-button type="primary" @click="visible_to_wifi=true;currentDeviceId=undefined">全部连接到某个wifi<a-icon type="retweet" /></a-button>-->
    <!--&lt;!&ndash;<a-button type="primary" @click="handleTest">全部连接到某个wifi<a-icon type="retweet" /></a-button>&ndash;&gt;-->
    <!--</div>-->

    <a-table
      :columns="columns"
      :dataSource="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      class="chatroom-table"
      style="font-size: 12px !important; margin-top: 10px"
    >
      <template slot="unique_id" slot-scope="text, record">
        <div class="editable-cell">
          <div
            v-if="choosedUniqueId == record._id"
            class="editable-cell-input-wrapper"
          >
            <a-input
              v-model="unique_id"
              ref="input"
              @pressEnter="checkUnique(record)"
              style="width: 70%; margin-right: 10px"
            ></a-input>
            <a-icon
              type="check"
              class="editable-cell-icon-check"
              @click="checkUnique(record)"
            ></a-icon>
          </div>
          <div v-else>
            <span>{{ record.unique_id }}</span>
            <a-icon
              type="edit"
              class="editable-cell-icon"
              v-bind:key="record._id"
              @click="editUnique(record)"
            ></a-icon>
          </div>
        </div>
      </template>
      <!-- 电量 -->
      <div slot="battery" slot-scope="text, record">
        <template v-if="record.battery && record.battery > 40">
          <a-tag color="green">
            {{ record.battery + "%" }}
          </a-tag>
        </template>
        <template v-if="record.battery && record.battery <= 40">
          <a-tag color="red">
            {{ record.battery + "%" }}
          </a-tag>
        </template>
      </div>
      <!-- 磁盘 -->
      <span slot="disk" slot-scope="text, record">
        <template v-if="record.disk">
          {{ record.disk + "%" }}
        </template>
      </span>
      <!-- 机器人信息 -->
      <div class="avatar-36-con" slot="nickname" slot-scope="text, record">
        <template v-if="record.bot_info.nickname">
          <img class="avatar" v-bind:src="record.bot_info.avatar_url" />
          <div class="nickname">{{ record.bot_info.nickname }}</div>
        </template>

        <span v-if="!record.bot_info.nickname"> 设备未登录微信号 </span>
      </div>
      <!-- 开机时间 -->
      <!--<template slot="open_time" slot-scope="text,record">-->
      <!--<span v-if="record.open_time">-->
      <!--{{$utils.getTimeByUnix(record.open_time)}}-->
      <!--</span>-->
      <!--</template>-->
      <!-- 机器人状态 -->
      <template slot="is_alive" slot-scope="text, record">
        <template v-if="record.is_alive == 1">
          <a-tag color="green"> 正常 </a-tag>
        </template>
        <template v-if="record.is_alive == 2">
          <a-tag color="red"> 待连接 </a-tag>
        </template>
        <template v-if="record.is_alive == 3">
          <a-tag color="red"> 失联 </a-tag>
        </template>
      </template>
      <!-- 损失原因 -->
      <!--<template slot="destroyed_remark" slot-scope="text,record">-->
      <!--<div class='editable-cell'>-->
      <!--<div v-if="choosedDestroy==record._id" class='editable-cell-input-wrapper'>-->
      <!--<a-input-->
      <!--v-model="destroyed_remark"-->
      <!--ref="input"-->
      <!--@pressEnter="checkDestroy(record)"-->
      <!--style="width: 70%; margin-right: 10px;"></a-input>-->
      <!--<a-icon-->
      <!--type='check'-->
      <!--class='editable-cell-icon-check'-->
      <!--@click="checkDestroy(record)"></a-icon>-->
      <!--</div>-->
      <!--<div v-else>-->
      <!--<span>{{record.destroyed_remark}}</span>-->
      <!--<a-icon type='edit' class='editable-cell-icon' v-bind:key='record._id'-->
      <!--@click="editDestroy(record)"></a-icon>-->
      <!--</div>-->
      <!--</div>-->

      <!--</template>-->

      <!-- 微信号 -->
      <template slot="bot_username" slot-scope="text, record">
        <div class="editable-cell">
          <div
            v-if="choosedWechat == record._id"
            class="editable-cell-input-wrapper"
          >
            <a-input
              v-model="bot_username"
              ref="input"
              @pressEnter="checkWechatId(record)"
              style="width: 70%; margin-right: 10px"
            ></a-input>
            <a-icon
              type="check"
              class="editable-cell-icon-check"
              @click="checkWechatId(record)"
            ></a-icon>
          </div>
          <div v-else>
            <span>{{ record.bot_username }}</span>
            <a-icon
              type="edit"
              class="editable-cell-icon"
              v-bind:key="record._id"
              @click="editWechatId(record)"
            ></a-icon>
          </div>
        </div>
      </template>

      <!-- 登录密码 -->
      <template slot="register_pwd" slot-scope="text, record">
        <div class="editable-cell">
          <div
            v-if="choosedRegist == record._id"
            class="editable-cell-input-wrapper"
          >
            <a-input
              v-model="register_pwd"
              ref="input"
              @pressEnter="checkRegistPwd(record)"
              style="width: 70%; margin-right: 10px"
            ></a-input>
            <a-icon
              type="check"
              class="editable-cell-icon-check"
              @click="checkRegistPwd(record)"
            ></a-icon>
          </div>
          <div v-else>
            <span>{{ record.register_pwd }}</span>
            <a-icon
              type="edit"
              class="editable-cell-icon"
              v-bind:key="record._id"
              @click="editRegistPwd(record)"
            ></a-icon>
          </div>
        </div>
      </template>

      <!-- 支付密码 -->
      <template slot="pay_pwd" slot-scope="text, record">
        <div class="editable-cell">
          <div
            v-if="choosedPay == record._id"
            class="editable-cell-input-wrapper"
          >
            <a-input
              v-model="pay_pwd"
              ref="input"
              @pressEnter="checkPayPwd(record)"
              style="width: 70%; margin-right: 10px"
            ></a-input>
            <a-icon
              type="check"
              class="editable-cell-icon-check"
              @click="checkPayPwd(record)"
            ></a-icon>
          </div>
          <div v-else>
            <span>{{ record.pay_pwd }}</span>
            <a-icon
              type="edit"
              class="editable-cell-icon"
              v-bind:key="record._id"
              @click="editPayPwd(record)"
            ></a-icon>
          </div>
        </div>
      </template>

      <!-- 物联卡 -->
      <template slot="iot" slot-scope="text, record">
        <div class="editable-cell">
          <div
            v-if="choosedIot == record._id"
            class="editable-cell-input-wrapper"
          >
            <a-input
              v-model="iot_value"
              ref="input"
              @pressEnter="checkIot(record)"
              style="width: 70%; margin-right: 10px"
            ></a-input>
            <a-icon
              type="check"
              class="editable-cell-icon-check"
              @click="checkIot(record)"
            ></a-icon>
          </div>
          <div v-else>
            <span>{{ record.iot }}</span>
            <a-icon
              type="edit"
              class="editable-cell-icon"
              v-bind:key="record._id"
              @click="editIot(record)"
            ></a-icon>
          </div>
        </div>
      </template>

      <!-- 手机卡 -->
      <template slot="sim" slot-scope="text, record">
        <div class="editable-cell">
          <div
            v-if="choosedSim == record._id"
            class="editable-cell-input-wrapper"
          >
            <a-input
              v-model="sim_value"
              ref="input"
              @pressEnter="checkSim(record)"
              style="width: 70%; margin-right: 10px"
            ></a-input>
            <a-icon
              type="check"
              class="editable-cell-icon-check"
              @click="checkSim(record)"
            ></a-icon>
          </div>
          <div v-else>
            <span>{{ record.sim }}</span>
            <a-icon
              type="edit"
              class="editable-cell-icon"
              v-bind:key="record._id"
              @click="editSim(record)"
            ></a-icon>
          </div>
        </div>
      </template>

      <template slot="email_address" slot-scope="text, record">
        <div class="editable-cell">
          <div
            v-if="choseEmail === record._id"
            class="editable-cell-input-wrapper"
          >
            <a-input
              v-model="email_value"
              ref="input"
              @pressEnter="checkEmail(record)"
              style="margin-right: 10px"
            ></a-input>
            <a-icon
              type="check"
              class="editable-cell-icon-check"
              @click="checkEmail(record)"
            ></a-icon>
          </div>
          <div v-else>
            <span>{{ record.email_address }}</span>
            <a-icon
              type="edit"
              class="editable-cell-icon"
              v-bind:key="record._id"
              @click="editEmailAddress(record)"
            ></a-icon>
          </div>
        </div>
      </template>

      <!-- 物联手机卡 -->
      <template slot="iot_sim" slot-scope="text, record">
        <div class="editable-cell">
          <div
            v-if="choosedIotSim == record._id"
            class="editable-cell-input-wrapper"
          >
            <a-input
              v-model="iotSim_value"
              ref="input"
              @pressEnter="checkIotSim(record)"
              style="width: 100px; margin-right: 10px"
            ></a-input>
            <a-icon
              type="check"
              class="editable-cell-icon-check"
              @click="checkIotSim(record)"
            ></a-icon>
          </div>
          <div v-else>
            <span>{{ record.iot_sim }}</span>
            <a-icon
              type="edit"
              class="editable-cell-icon"
              v-bind:key="record._id"
              @click="editIotSim(record)"
            ></a-icon>
          </div>
        </div>
      </template>

      <!-- 设备位置 -->
      <template slot="location" slot-scope="text, record">
        <div class="editable-cell">
          <div
            v-if="choosedLoc == record._id"
            class="editable-cell-input-wrapper"
          >
            <a-input
              v-model="location_value"
              ref="input"
              @pressEnter="checkLocation(record)"
              style="width: 100px; margin-right: 10px"
            ></a-input>
            <a-icon
              type="check"
              class="editable-cell-icon-check"
              @click="checkLocation(record)"
            ></a-icon>
          </div>
          <div v-else>
            <span>{{ record.location }}</span>
            <a-icon
              type="edit"
              class="editable-cell-icon"
              v-bind:key="record._id"
              @click="editLocation(record)"
            ></a-icon>
          </div>
        </div>
      </template>

      <!-- 操作 -->
      <template slot="actions" slot-scope="text, record">
        <a-dropdown>
          <a-menu slot="overlay" @click="handleMenuClick($event, record)">
            <a-menu-item key="detail">查看详情</a-menu-item>
            <!--<a-menu-item key='destroy_reason'>损失原因</a-menu-item>-->
            <a-menu-item key="remark">添加备注</a-menu-item>
            <a-menu-item key="time">增加时间</a-menu-item>
            <a-menu-item key="clear_record">刷机记录</a-menu-item>
            <a-menu-item key="delete_device_net_statistic"
              >重新统计物联网卡信息</a-menu-item
            >
            <a-menu-item key="shutdown">关机</a-menu-item>
            <a-menu-item key="reboot">重启</a-menu-item>
          </a-menu>
          <a-button>
            操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </template>
    </a-table>

    <!-- 输入纯命令 -->
    <template>
      <div>
        <a-modal
          title="输入命令"
          :visible="visible_naked"
          @ok="handleNakedOk"
          :confirmLoading="confirmLoading_naked"
          @cancel="handleNakedCancel"
        >
          <a-input v-model="command" placeholder="填写命令" />
        </a-modal>
      </div>
    </template>

    <!-- 切换至指定wifi -->
    <template>
      <div>
        <a-modal
          title="切换wifi"
          :visible="visible_to_wifi"
          @ok="handleToWifiOk"
          :confirmLoading="confirmLoading_to_wifi"
          @cancel="handleToWifiCancel"
        >
          <a-input v-model="to_wifi_SSID" placeholder="WIFI名" />
          <div style="margin-top: 16px">
            <a-input v-model="to_wifi_password" placeholder="WIFI密码" />
          </div>
        </a-modal>
      </div>
    </template>

    <!-- 忘记某个网段 -->
    <template>
      <div>
        <a-modal
          title="清除一个wifi"
          :visible="visible_clear_certain_wifi_all"
          @ok="handleClearCertainWifiAllOK"
          :confirmLoading="confirmLoading_clear_certain_wifi_all"
          @cancel="handleClearCertainWifiAllCancel"
        >
          <a-input
            v-model="clear_certain_wifi_all_SSID"
            placeholder="想要清除的WIFI名"
          />
        </a-modal>
      </div>
    </template>

    <!-- 设备详情 -->
    <template>
      <div>
        <a-modal
          title="详细信息"
          v-model="visible_detail"
          :closable="false"
          @ok="handleDetailOK"
          :footer="null"
        >
          <div>
            物联网卡供应商：
            <a-select
              @select="bindProvider($event, choosedRecord, 'iot_provider')"
              v-model="choosedRecord.iot_provider"
              style="width: 200px; margin-bottom: 5px"
            >
              <a-select-option
                v-for="provider in provider_list"
                :value="provider.u_provider_id"
              >
                {{ provider.provider_name }}
              </a-select-option>
            </a-select>
          </div>
          <div>
            号源：
            <a-select
              @select="bindProvider($event, choosedRecord, 'wechat_provider')"
              v-model="choosedRecord.wechat_provider"
              style="width: 200px; margin-bottom: 5px"
            >
              <a-select-option
                v-for="provider in provider_list"
                :value="provider.u_provider_id"
              >
                {{ provider.provider_name }}
              </a-select-option>
            </a-select>
          </div>
          <div>
            4G 卡源：
            <a-select
              @select="bindProvider($event, choosedRecord, 'four_g_provider')"
              v-model="choosedRecord.four_g_provider"
              style="width: 200px; margin-bottom: 5px"
            >
              <a-select-option
                v-for="provider in provider_list"
                :value="provider.u_provider_id"
              >
                {{ provider.provider_name }}
              </a-select-option>
            </a-select>
          </div>
          <div>
            电量：
            <template
              v-if="choosedRecord.battery && choosedRecord.battery > 40"
            >
              <a-tag color="green">
                {{ choosedRecord.battery + "%" }}
              </a-tag>
            </template>
            <template
              v-if="choosedRecord.battery && choosedRecord.battery <= 40"
            >
              <a-tag color="red">
                {{ choosedRecord.battery + "%" }}
              </a-tag>
            </template>
          </div>
          <div>磁盘占用：{{ choosedRecord.disk }}</div>
          <div>微信插件版本：{{ choosedRecord.xposed_ver }}</div>
          <div>大黄脸版本：{{ choosedRecord.manager_ver }}</div>
          <div>IP 地址：{{ choosedRecord.ip }}</div>
          <div>
            开机时间：{{ $utils.getTimeByUnix(choosedRecord.open_time) }}
          </div>
          <div>损失原因：{{ choosedRecord.destroyed_remark }}</div>
          <div>话费：{{ choosedRecord.bill }}</div>
          <div>当前网络：{{ choosedRecord.wifi }}</div>
          <div>操作人：{{ choosedRecord.last_mod_username }}</div>
          <div>
            买入时间：{{
              choosedRecord.buy_time
                ? $utils.getTimeByUnix(choosedRecord.buy_time * 1000)
                : ""
            }}
          </div>
          <div>
            创建时间（上系统）：{{
              $utils.getTimeByUnix(choosedRecord.create_time * 1000)
            }}
          </div>
          <div>
            首次分配时间：{{
              choosedRecord.distribute_time
                ? $utils.getTimeByUnix(choosedRecord.distribute_time * 1000)
                : ""
            }}
          </div>
          <div>备注：{{ choosedRecord.remark }}</div>
          <!--<img :src="device.qr_code">-->
        </a-modal>
      </div>
    </template>

    <!-- 标记损失 -->
    <template>
      <div>
        <a-modal
          title="标记损失"
          :visible="visible_lose"
          @ok="handleLoseOk"
          @cancel="handleLoseCancel"
        >
          <div style="display: flex; flex-direction: column">
            <a-radio-group v-model="is_destroy_value">
              当前状态设置：
              <a-radio :value="1">正在服务</a-radio>
              <a-radio :value="2">彻底损失</a-radio>
            </a-radio-group>
            <span
              v-if="is_destroy_value == 2"
              style="
                margin-top: 10px;
                display: flex;
                white-space: nowrap;
                align-items: center;
              "
            >
              损失原因:<a-input
                v-model="destroyed_remark"
                placeholder="填写损失原因"
              />
            </span>
          </div>
        </a-modal>
      </div>
    </template>

    <!-- 添加备注 -->
    <template>
      <div>
        <a-modal
          title="添加备注"
          :visible="visible_remark"
          @ok="handleRemarkOk"
          @cancel="handleRemarkCancel"
        >
          <div style="display: flex; flex-direction: column">
            添加备注:
            <a-input v-model="remark" placeholder="添加备注" />
          </div>
        </a-modal>
      </div>
    </template>

    <!-- 刷机记录 -->
    <template>
      <div>
        <a-modal
          :title="'刷机记录: ' + choosedRecord.unique_id"
          v-model="visible_clear_record"
          :closable="false"
          :footer="null"
        >
          <div style="display: inline-block; margin-bottom: 20px">
            <label title="新增刷机记录" class="info">新增刷机记录</label>
            <a-input
              style="max-width: 150px; margin-right: 20px"
              placeholder="备注"
              v-model="clear_remark"
            ></a-input>
            <a-button
              type="primary"
              @click="newClearLog(choosedRecord, clear_remark)"
              >新增</a-button
            >
          </div>
          <div v-if="visible_clear_record_loading">正在获取历史刷机记录...</div>
          <div v-else>
            <div v-if="clear_record_list.length === 0">暂无</div>
            <div v-else>
              <div v-for="clear_record in clear_record_list">
                <span>
                  {{
                    "时间: " +
                    $utils.getTimeByUnix(clear_record.create_time * 1000)
                  }}
                </span>
                <span> {{ "操作人: " + clear_record.username }} </span>
                <span> {{ "备注: " + clear_record.clear_remark }} </span>
              </div>
            </div>
          </div>
        </a-modal>
      </div>
    </template>

    <!-- 添加备注 -->
    <template>
      <div>
        <a-modal
          title="时间信息"
          :visible="visible_time"
          @ok="handleTimeOk"
          @cancel="handleTimeCancel"
        >
          <div style="display: flex; flex-direction: column">
            <div>
              买入时间:
              <a-date-picker
                @change="changeBuyDate"
                style="width: 200px"
              ></a-date-picker>
              <a-time-picker @change="changeBuyTime"></a-time-picker>
            </div>
            <div>
              首次分配时间:
              <a-date-picker
                @change="changeDisDate"
                style="width: 200px"
              ></a-date-picker>
              <a-time-picker @change="changeDisTime"></a-time-picker>
            </div>
          </div>
        </a-modal>
      </div>
    </template>
    <!--&lt;!&ndash; 编辑密码 &ndash;&gt;-->
    <!--<template>-->
    <!--<div>-->
    <!--<a-modal-->
    <!--title="编辑密码"-->
    <!--:visible="visible_to_pwd"-->
    <!--@ok="handPwdModifyOk"-->
    <!--:confirmLoading="confirmLoading_to_pwd"-->
    <!--@cancel="handlePwdModifyCancel"-->
    <!--&gt;-->
    <!--登录密码：<a-input v-model="login_pwd_value" placeholder="登录密码"/>-->
    <!--支付密码：<a-input v-model="pay_pwd_value" placeholder="支付密码" />-->
    <!--</a-modal>-->
    <!--</div>-->
    <!--</template>-->

    <!--&lt;!&ndash;手机卡信息&ndash;&gt;-->
    <!--<template>-->
    <!--<div>-->
    <!--<a-modal-->
    <!--title="手机卡信息"-->
    <!--:visible="visible_to_simcard"-->
    <!--@ok="handleMobileInfoOk"-->
    <!--:confirmLoading="confirmLoading_to_simcard"-->
    <!--@cancel="handleMobileInfoCancel"-->
    <!--&gt;-->
    <!--手机卡信息：<a-input v-model="mobile_card_value" placeholder="手机卡信息"/>-->
    <!--物联卡信息：<a-input v-model="card_value" placeholder="物联卡信息" />-->
    <!--</a-modal>-->
    <!--</div>-->
    <!--</template>-->
  </div>
</template>
<!--</div>-->
<!--</template>-->
<script>
import "../config/global";
import AButton from "ant-design-vue/es/button/button";
import moment from "moment";

const axios = require("axios");

const columns = [
  {
    title: "唯一ID",
    dataIndex: "unique_id",
    width: "80px",
    scopedSlots: { customRender: "unique_id" },
  },
  {
    title: "设备序列号",
    width: "95px",
    dataIndex: "device_id",
  },
  {
    title: "机器人",
    dataIndex: "nickname",
    // width: '60px',
    scopedSlots: { customRender: "nickname" },
  },
  {
    title: "微信号",
    dataIndex: "bot_username",
    width: "170px",
    scopedSlots: { customRender: "bot_username" },
  },
  {
    title: "登录密码",
    dataIndex: "register_pwd",
    width: "80px",
    scopedSlots: { customRender: "register_pwd" },
  },
  {
    title: "支付密码",
    dataIndex: "pay_pwd",
    width: "80px",
    scopedSlots: { customRender: "pay_pwd" },
  },
  // {
  //   title: '物联卡',
  //   dataIndex: 'iot',
  //   scopedSlots: {customRender: 'iot'}
  // },
  {
    title: "手机卡",
    dataIndex: "sim",
    width: "120px",
    scopedSlots: { customRender: "sim" },
  },
  {
    title: "绑定邮箱",
    dataIndex: "email_address",
    width: "120px",
    scopedSlots: { customRender: "email_address" },
  },
  {
    title: "物联手机卡",
    dataIndex: "iot_sim",
    width: "180px",
    scopedSlots: { customRender: "iot_sim" },
  },
  {
    title: "位置",
    dataIndex: "location",
    width: "100px",
    scopedSlots: { customRender: "location" },
  },
  // {
  //   title: '电量',
  //   dataIndex: 'battery',
  //   scopedSlots: {customRender: 'battery'}
  // },
  // {
  //   title: '磁盘占用',
  //   dataIndex: 'disk',
  //   scopedSlots: {customRender: 'disk'}
  // },
  // {
  //   title: '内核版本',
  //   dataIndex: 'xposed_ver'
  // },
  // {
  //   title: '大黄脸版本',
  //   dataIndex: 'manager_ver'
  // },
  // {
  //   title: 'IP地址',
  //   dataIndex: 'ip'
  // },
  // {
  //   title: '开机时间',
  //   dataIndex: 'open_time',
  //   scopedSlots: {customRender: 'open_time'}
  // },
  // {
  //   title: '损失原因',
  //   dataIndex: 'destroyed_remark',
  //   // scopedSlots: {customRender: 'destroyed_remark'}
  // },
  // {
  //   title: '话费',
  //   dataIndex: 'bill'
  // },
  // {
  //   title: '当前网络',
  //   dataIndex: 'wifi'
  // },
  // {
  //   title: '设备状态',
  //   dataIndex: 'is_alive',
  //   scopedSlots: {customRender: 'is_alive'}
  // },
  // {
  //   title: '操作人',
  //   dataIndex: 'last_mod_username',
  // },
  // {
  //   title: '备注',
  //   dataIndex: 'remark',
  // },
  {
    title: "操作",
    dataIndex: "actions",
    scopedSlots: { customRender: "actions" },
  },
];
const now = moment(new Date().getTime());

export default {
  components: { AButton },
  name: "DeviceManage",
  data() {
    return {
      columns,
      loading: false,
      data: [],
      dataTotal: [],
      command: "",
      to_wifi_SSID: "",
      to_wifi_password: "",
      clear_certain_wifi_all_SSID: "",
      confirmLoading_naked: false,
      confirmLoading_to_wifi: false,
      confirmLoading_clear_certain_wifi_all: false,
      visible_naked: false,
      visible_to_wifi: false,
      visible_clear_certain_wifi_all: false,
      currentDeviceId: undefined,
      visible_to_pwd: false,
      visible_to_simcard: false,
      visible_detail: false,
      confirmLoading_to_pwd: false,
      confirmLoading_to_simcard: false,
      register_pwd_value: false,
      pay_pwd_value: false,
      mobile_card_value: false,
      card_value: false,
      editable: false,
      choosedDestroy: "",
      choosedWechat: "",
      choosedRegist: "",
      choosedPay: "",
      choosedUniqueId: "",
      unique_id: "",
      new_unique_id: "",
      min_wechat_ver: "",
      min_manager_ver: "",
      destroyed_remark: "",
      bot_username: "",
      detailData: {},
      provider_list: [],
      register_pwd: "",
      pay_pwd: "",
      choosedIot: "",
      iot_value: "",
      choosedSim: "",
      sim_value: "",
      choosedIotSim: "",
      iotSim_value: "",
      visible_lose: false,
      is_destroy_value: 0,
      choosedRecord: "",
      visible_clear_record: false,
      visible_clear_record_loading: false,
      clear_record_list: [],
      clear_remark: "",
      confirmLoading_abnormal: false,
      visible_remark: false,
      remark: "",
      new_device: false,
      search_device_id: "",
      choosedLoc: "",
      location_value: "",
      visible_time: false,
      buy_time: null,
      distribute_time: null,
      choseEmail: undefined,
      email_value: undefined,
      pagination: {
        hideOnSinglePage: false,
        total: 0,
        showTotal: (total) => `共 ${total} 台设备`,
        pageSize: 10,
        current: 1,
      },
      search_bot_username: ""
    };
  },
  computed: {
    getDeviceListUrl: function () {
      return global.DOMAIN + global.API_VERSION + "udevice/get_devices";
    },
    getClearRecordList: function () {
      return (
        global.DOMAIN + global.API_VERSION + "udevice/get_clear_record_list"
      );
    },
    deleteDeviceNetStatisticUrl: function () {
      return (
        global.DOMAIN +
        global.API_VERSION +
        "udevice/delete_device_net_statistic"
      );
    },
    newClearRecord: function () {
      return global.DOMAIN + global.API_VERSION + "udevice/new_clear_record";
    },
    getCommandBroadcastUrl: function () {
      return global.DOMAIN + global.API_VERSION + "broadcast";
    },
    getCommandTargetsUrl: function () {
      return global.DOMAIN + global.API_VERSION + "targets";
    },
    getDeviceDelete: function () {
      return global.DOMAIN + global.API_VERSION + "delete_device";
    },
    setDeviceInfo: function () {
      return global.DOMAIN + global.API_VERSION + "UDevice/set_device_info";
    },
    setMinVer: function () {
      return global.DOMAIN + global.API_VERSION + "UDevice/set_min_version";
    },
    getMinVer: function () {
      return global.DOMAIN + global.API_VERSION + "UDevice/get_min_version";
    },
    setDeviceDestroy: function () {
      return (
        global.DOMAIN + global.API_VERSION + "UDevice/set_device_destroyed"
      );
    },
    bindProviderUrl: function () {
      return global.DOMAIN + global.API_VERSION + "UDevice/bind_provider";
    },
    getProviderListUrl: function () {
      return global.DOMAIN + global.API_VERSION + "uprovider/get_provider_list";
    },
  },
  created() {
    this.getDeviceList();
    this.getProviderList();
    this.getMinVersion();
  },
  methods: {
    getDeviceList() {
      this.loading = true;
      axios
        .post(this.getDeviceListUrl, {
          token: sessionStorage.token,
          page: this.pagination.current,
          pagesize: this.pagination.pageSize,
          unique_id: this.search_device_id,
          bot_username: this.search_bot_username
        })
        .then((res) => {
          this.loading = false;

          let data = res.data;
          if (data.err_code === 0) {
            data.content.devices.forEach((device) => {
              if (!device.bot_info) device.bot_info = {};
            });
            this.data = data.content.devices;
            this.dataTotal = data.content.devices;
            this.pagination.total = data.content.total;
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;
      this.getDeviceList();
    },
    getProviderList() {
      axios
        .post(this.getProviderListUrl, {
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            this.provider_list = data.data.content.provider_list;
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },

    broadcastClick(task) {
      console.log("发送一条全部指令：" + task);
      this.commandBroadcast({
        task: task,
      });
    },

    commandBroadcast(params) {
      return axios
        .post(this.getCommandBroadcastUrl, {
          token: sessionStorage.token,
          content: params,
        })
        .then((res) => {
          let data = res.data;
          if (data.err_code === 0) {
          } else {
            alert(this.getCommandBroadcastUrl + ":  " + data.err_code);
          }
        });
    },

    commandTargets(targets, params) {
      return axios
        .post(this.getCommandTargetsUrl, {
          token: sessionStorage.token,
          device_id: targets,
          content: params,
        })
        .then((res) => {
          let data = res.data;
          if (data.err_code === 0) {
          } else {
            alert(this.getCommandTargetsUrl + ":  " + data.err_code);
          }
        });
    },

    handleMenuClick(e, record) {
      let key = e.key;
      let task = key.split(",")[0];
      let targetId = key.split(",")[1];

      console.log(`task:${task} targetId:${targetId}`);

      if (task === "detail") {
        this.visible_detail = true;
        this.dataDetail = e;
        this.choosedRecord = record;
        return;
      } else if (task === "command_naked") {
        this.visible_naked = true;
        this.currentDeviceId = targetId;
        return;
      } else if (task === "change_to_wifi") {
        this.visible_to_wifi = true;
        this.currentDeviceId = targetId;
        return;
      } else if (task === "delete") {
        axios
          .post(this.getDeviceDelete, {
            token: sessionStorage.token,
            device_id: targetId,
          })
          .then((res) => {
            let data = res.data;
            if (data.err_code === 0) {
              this.getDeviceList();
            } else {
              alert(this.getDeviceDelete() + ":  " + data.err_code);
            }
          });
        return;
      } else if (task === "pwd_modify") {
        this.visible_to_wifi = true;
        this.currentDeviceId = targetId;
        return;
      } else if (task === "destroy_reason") {
        this.visible_lose = true;
        this.choosedRecord = record;
        this.is_destroy_value = record.destroyed_remark ? 2 : 1;
        this.destroyed_remark = record.destroyed_remark;
        this.showLoseMessage(record);
        return;
      } else if (task === "remark") {
        this.visible_remark = true;
        this.choosedRecord = record;
        this.remark = record.remark;
        return;
      } else if (task === "time") {
        this.visible_time = true;
        this.choosedRecord = record;
        if (record.buy_time && record.distribute_time) {
          this.buy_time = moment(new Date(record.buy_time));
          this.distribute_time = moment(new Date(record.distribute_time));
        }
        return;
      } else if (task === "clear_record") {
        this.visible_clear_record = true;
        this.choosedRecord = record;
        this.fetchClearRecordList(record.unique_id);
        return;
      } else if (task === "delete_device_net_statistic") {
        this.deleteDeviceNetStatistic(record);
        return;
      } else if (task === "shutdown") {
        if (!record.bot_username) {
          this.$message.error("不能关机");
        } else {
          let self = this;
          this.$confirm({
            title: "确认",
            content: "确认关机吗？",
            onOk() {
              self.shutdown(record);
            },
          });
        }
        return;
      } else if (task === "reboot") {
        if (!record.bot_username) {
          this.$message.error("不能重启");
        } else {
          let self = this;
          this.$confirm({
            title: "确认",
            content: "确认重启吗？",
            onOk() {
              self.reboot(record);
            },
          });
        }
        return;
      }

      this.commandTargets([targetId], {
        task: task,
      });
    },
    shutdown(record) {
      axios
        .post(global.DOMAIN + global.API_VERSION + "udevice/shutdown_device", {
          bot_username: record.bot_username,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            window.alert("关机成功");
          }
        });
    },
    reboot(record) {
      axios
        .post(global.DOMAIN + global.API_VERSION + "udevice/reboot_device", {
          bot_username: record.bot_username,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            window.alert("重启成功");
          }
        });
    },

    deleteDeviceNetStatistic(record) {
      axios
        .post(this.deleteDeviceNetStatisticUrl, {
          device_id: record.device_id,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            window.alert("重置成功");
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    fetchClearRecordList(unique_id) {
      this.visible_clear_record_loading = true;
      axios
        .post(this.getClearRecordList, {
          unique_id: unique_id,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            this.clear_record_list = data.data.content.clear_record_list;
            this.visible_clear_record_loading = false;
            // console.log('dataList', dataList)
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    newClearLog(choosedRecord, clear_remark) {
      axios
        .post(this.newClearRecord, {
          unique_id: choosedRecord.unique_id,
          clear_remark: clear_remark,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            this.clear_record_list.push(data.data.content.clear_record);
            this.clear_remark = "";
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    handleNakedOk() {
      this.confirmLoading_naked = true;

      if (this.command) {
        this.commandTargets([this.currentDeviceId], {
          task: "command_naked",
          content: this.command,
        }).then(() => {
          this.confirmLoading_naked = false;
          this.currentDeviceId = undefined;
          this.command = "";
          this.visible_naked = false;
        });
      } else {
        this.$message.error("命令不能为空");
      }
    },

    handleNakedCancel() {
      console.log("Clicked cancel button");
      this.confirmLoading_naked = false;
      this.currentDeviceId = undefined;
      this.command = "";
      this.visible_naked = false;
    },

    handleToWifiOk() {
      this.confirmLoading_to_wifi = true;

      if (this.to_wifi_SSID && this.to_wifi_password) {
        if (this.currentDeviceId) {
          this.commandTargets([this.currentDeviceId], {
            task: "change_to_wifi",
            content: {
              ssid: this.to_wifi_SSID,
              password: this.to_wifi_password,
            },
          }).then(() => {
            this.confirmLoading_to_wifi = false;
            this.currentDeviceId = undefined;
            this.to_wifi_password = "";
            this.to_wifi_SSID = "";
            this.visible_to_wifi = false;
          });
        } else {
          this.commandBroadcast({
            task: "change_to_wifi",
            content: {
              ssid: this.to_wifi_SSID,
              password: this.to_wifi_password,
            },
          }).then(() => {
            this.confirmLoading_to_wifi = false;
            this.currentDeviceId = undefined;
            this.to_wifi_password = "";
            this.to_wifi_SSID = "";
            this.visible_to_wifi = false;
          });
        }
      } else {
        this.$message.error("wifi名和密码不能为空");
      }
    },

    handleToWifiCancel() {
      this.confirmLoading_to_wifi = false;
      this.currentDeviceId = undefined;
      this.to_wifi_password = "";
      this.to_wifi_SSID = "";
      this.visible_to_wifi = false;
    },

    refreshClick() {
      this.getDeviceList();
    },

    outputNetExcel() {
      // console.log('outputExcel', this.getChatroomListExcelUrl)
      let baseUrl =
        global.DOMAIN +
        global.API_VERSION +
        "udevice/get_net_statistics_excel?";
      console.log("outputExcel", baseUrl);
      let now = parseInt(new Date().getTime() / 1000);
      baseUrl += "start_time=" + (now - 7 * 24 * 60 * 60) + "&end_time=" + now;
      baseUrl += "&token" + "=" + sessionStorage.token;
      console.log("outputExcel", baseUrl);
      window.open(baseUrl, "_blank");
    },

    handleClearCertainWifiAllOK() {
      this.confirmLoading_clear_certain_wifi_all = true;

      if (this.clear_certain_wifi_all_SSID) {
        this.commandBroadcast({
          task: "clear_wifi",
          content: this.clear_certain_wifi_all_SSID,
        }).then(() => {
          this.confirmLoading_clear_certain_wifi_all = false;
          this.currentDeviceId = undefined;
          this.clear_certain_wifi_all_SSID = "";
          this.visible_clear_certain_wifi_all = false;
        });
      } else {
        this.$message.error("必须填写wifi名称");
      }
    },

    handleClearCertainWifiAllCancel() {
      this.confirmLoading_clear_certain_wifi_all = false;
      this.currentDeviceId = undefined;
      this.clear_certain_wifi_all_SSID = "";
      this.visible_clear_certain_wifi_all = false;
    },

    handPwdModifyOk() {
      this.commandBroadcast({
        task: "clear_wifi",
        content: this.clear_certain_wifi_all_SSID,
      }).then(() => {
        this.confirmLoading_clear_certain_wifi_all = false;
        this.currentDeviceId = undefined;
        this.clear_certain_wifi_all_SSID = "";
        this.visible_clear_certain_wifi_all = false;
      });
    },

    handlePwdModifyCancel() {
      this.visible_to_pwd = false;
    },

    // checkDestroy (record) {
    //   axios.post(this.setDeviceDestroy, {
    //     device_id: record.device_id,
    //     is_destroyed: true,
    //     destroyed_remark: this.destroyed_remark
    //   }).then(() => {
    //     this.choosedDestroy = undefined
    //   })
    // },
    // editDestroy (record) {
    //   this.choosedDestroy = record._id
    //   this.destroyed_remark = record.destroyed_remark
    // },
    checkWechatId(record) {
      axios
        .post(this.setDeviceInfo, {
          bot_username: this.bot_username,
          u_device_id: record._id,
          token: sessionStorage.token,
        })
        .then(() => {
          record.bot_username = this.bot_username;
          this.choosedWechat = undefined;
        });
    },
    editWechatId(record) {
      this.choosedWechat = record._id;
      this.bot_username = record.bot_username;
    },
    checkRegistPwd(record) {
      axios
        .post(this.setDeviceInfo, {
          register_pwd: this.register_pwd,
          u_device_id: record._id,
          token: sessionStorage.token,
        })
        .then(() => {
          record.register_pwd = this.register_pwd;
          this.choosedRegist = undefined;
        });
    },
    editRegistPwd(record) {
      this.choosedRegist = record._id;
      this.register_pwd = record.register_pwd;
    },
    checkPayPwd(record) {
      axios
        .post(this.setDeviceInfo, {
          pay_pwd: this.pay_pwd,
          u_device_id: record._id,
          token: sessionStorage.token,
        })
        .then(() => {
          record.pay_pwd = this.pay_pwd;
          this.choosedPay = undefined;
        });
    },
    editPayPwd(record) {
      this.choosedPay = record._id;
      this.pay_pwd = record.pay_pwd;
    },
    checkUnique(record) {
      axios
        .post(this.setDeviceInfo, {
          unique_id: this.unique_id,
          u_device_id: record._id,
          token: sessionStorage.token,
        })
        .then((res) => {
          record.unique_id = res.data.content.unique_id;
          this.choosedUniqueId = undefined;
        });
    },
    editUnique(record) {
      this.choosedUniqueId = record._id;
      this.unique_id = record.unique_id;
      this.unique_id = "";
    },
    checkIot(record) {
      axios
        .post(this.setDeviceInfo, {
          iot: this.iot_value,
          u_device_id: record._id,
          token: sessionStorage.token,
        })
        .then((res) => {
          this.choosedIot = undefined;
          record.iot = res.data.content.iot;
          this.iot_value = "";
        });
    },
    editIot(record) {
      this.choosedIot = record._id;
      this.iot_value = record.iot;
    },
    checkSim(record) {
      axios
        .post(this.setDeviceInfo, {
          sim: this.sim_value,
          u_device_id: record._id,
          token: sessionStorage.token,
        })
        .then((res) => {
          console.log(res);
          this.choosedSim = undefined;
          record.sim = res.data.content.sim;
          this.sim_value = "";
        });
    },
    checkEmail(record) {
      axios
        .post(this.setDeviceInfo, {
          email_address: this.email_value,
          u_device_id: record._id,
          token: sessionStorage.token,
        })
        .then((res) => {
          this.choseEmail = undefined;
          record.email_address = res.data.content.email_address;
          this.email_value = undefined;
        });
    },
    editSim(record) {
      this.choosedSim = record._id;
    },
    checkIotSim(record) {
      axios
        .post(this.setDeviceInfo, {
          u_device_id: record._id,
          iot_sim: this.iotSim_value,
          token: sessionStorage.token,
        })
        .then((res) => {
          console.log(res);
          this.choosedIotSim = undefined;
          record.iot_sim = res.data.content.iot_sim;
          this.iot_sim = "";
        });
    },
    editIotSim(record) {
      this.choosedIotSim = record._id;
    },
    handleDetailOK() {
      this.visible_detail = false;
    },
    showLoseMessage() {},
    handleLoseOk() {
      axios
        .post(this.setDeviceInfo, {
          u_device_id: this.choosedrecord._id,
          is_destroyed: this.is_destroy_value - 1,
          destroyed_remark: this.destroyed_remark,
          token: sessionStorage.token,
        })
        .then(() => {
          this.visible_lose = false;
        });
    },
    handleLoseCancel() {
      this.visible_lose = false;
    },
    newDevice() {
      if (this.new_unique_id === "") {
        window.alert("唯一ID 不能为空！");
        return;
      }
      axios
        .post(this.setDeviceInfo, {
          unique_id: this.new_unique_id,
          token: sessionStorage.token,
        })
        .then(() => {
          this.new_unique_id = "";
          this.getDeviceList();
        });
    },
    setMinVersion() {
      if (this.min_wechat_ver === "" || this.min_manager_ver === "") {
        window.alert("版本号不能为空！");
        return;
      }
      axios
        .post(this.setMinVer, {
          min_wechat_version: this.min_wechat_ver,
          min_manager_version: this.min_manager_ver,
          token: sessionStorage.token,
        })
        .then(() => {
          //
        });
    },
    getMinVersion() {
      axios
        .post(this.getMinVer, {
          token: sessionStorage.token,
        })
        .then((res) => {
          if (res.data.err_code === 0) {
            this.min_wechat_ver = res.data.content.min_wechat_version;
            this.min_manager_ver = res.data.content.min_manager_version;
          }
        });
    },
    handleRemarkOk() {
      console.log(this.choosedRecord);
      axios
        .post(this.setDeviceInfo, {
          u_device_id: this.choosedrecord._id,
          remark: this.remark,
          token: sessionStorage.token,
        })
        .then(() => {
          this.remark = "";
          this.visible_remark = false;
          this.getDeviceList();
        });
    },
    handleRemarkCancel() {
      this.visible_remark = false;
    },
    addDevice() {
      this.new_device = true;
    },
    searchDevice() {
      this.pagination.current = 1;
      this.getDeviceList();
    },
    cancelSearchDevice() {
      this.search_device_id = ""
      this.search_bot_username= ""
      this.searchDevice()
    },
    hideDevice() {
      this.new_device = false;
    },
    checkLocation(record) {
      axios
        .post(this.setDeviceInfo, {
          u_device_id: record._id,
          location: this.location_value,
          token: sessionStorage.token,
        })
        .then(() => {
          this.choosedLoc = "";
          this.location_value = "";
          record.location = this.location_value;
          this.getDeviceList();
        });
    },
    editLocation(record) {
      this.choosedLoc = record._id;
    },
    handleTimeOk() {
      axios
        .post(this.setDeviceInfo, {
          u_device_id: this.choosedrecord._id,
          buy_time: this.buy_date + this.buy_time,
          distribute_time: this.distribute_date + this.distribute_time,
          token: sessionStorage.token,
        })
        .then(() => {
          this.buy_time = now;
          this.distribute_time = now;
          this.getDeviceList();
          this.visible_time = false;
        });
    },
    handleTimeCancel() {
      this.visible_time = false;
    },
    changeBuyDate(date) {
      this.buy_date = new Date(date).getTime() - now;
    },
    changeBuyTime(time) {
      this.buy_time = new Date(time).getTime() - today;
    },
    changeDisDate(date) {
      this.distribute_date = new Date(date).getTime() - now;
    },
    changeDisTime(time) {
      this.distribute_time = new Date(time).getTime() - today;
    },
    bindProvider(e, record, type) {
      if (e === record[type]) {
        return;
      }
      axios
        .post(this.bindProviderUrl, {
          u_provider_id: e,
          provider_type: type,
          unique_id: record.unique_id,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            record[type] = e;
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    editEmailAddress(record) {
      this.choseEmail = record._id;
    },
  },
};
</script>
